import { makeRequest } from "src/services/restcall";
import { ApiResponse } from "src/services/types";
import HttpMethod from '../../services/httpMethods'

export async function getAllSourceTableAPI(): Promise<ApiResponse>{
    return await makeRequest(HttpMethod.GET, '/api/emissionsource/source',{})
}
export async function getSourceByIdAPI(value:string): Promise<ApiResponse>{
    return await makeRequest(HttpMethod.GET, '/api/emissionsource/source/id/' + value, {})
}
export async function postRegisterSourceAPI(value: Object): Promise<ApiResponse>{
    return await makeRequest(HttpMethod.POST, '/api/emissionsource/source', value)
}
export async function putUpdateSourceAPI(value: Object) : Promise<ApiResponse>{
    return await makeRequest(HttpMethod.PUT, '/api/emissionsource/source',value)
}
